var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-check-solid",
    d: "M5,1V2H9V1a1,1,0,0,1,2,0V2h1.5A1.5,1.5,0,0,1,14,3.5V5H0V3.5A1.5,1.5,0,0,1,1.5,2H3V1A1,1,0,0,1,5,1ZM0,6H14v8.5A1.5,1.5,0,0,1,12.5,16H1.5A1.5,1.5,0,0,1,0,14.5ZM10.253,9.5a.679.679,0,0,0,0-1.034.722.722,0,0,0-1.034,0L6.25,11.441l-1.5-1.472A.731.731,0,0,0,3.719,11l2,2a.679.679,0,0,0,1.034,0Z",
    fill: "#cbd2d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckSolid);
export default __webpack_public_path__ + "static/media/calendar-check-solid.075b0a7ee495c2222751ebc9a0713646.svg";
export { ForwardRef as ReactComponent };